
import useSWR from "swr";
import { customAuthAxios } from "../../src/utils/customAuthAxios";

export type FirstViewOption = {
    id: string;
    name: string;
    url: string;
    addon_id: string;
    addon_name: string;
};

export type FirstViewData = {
    restaurant_id: string;
    current_first_view: FirstViewOption;
    available_first_views: FirstViewOption[];
    plan_info: {
        id: string;
        name: string;
    };
    plan_addon_ids: string[];
    restaurant_addon_ids: string[];
};

// カスタムfetcher関数でエラーハンドリング
const fetchFirstViewOptions = async (url: string): Promise<FirstViewData | null> => {
    try {
        const response = await customAuthAxios.get(url);
        return response.data;
    } catch (error) {
        console.error('First view options fetch error:', error);
        // エラーが発生した場合はnullを返して、UIをクラッシュさせない
        return null;
    }
};

export const useFetchFirstViewOptions = (restaurantId: string | undefined) => {
    // 一時的にrestaurantIdからハイフンを除去
    const restaurantIdWithoutHyphens = restaurantId?.replace(/-/g, '');

    const { data, error, isLoading } = useSWR<FirstViewData | null>(
        restaurantIdWithoutHyphens ? `general_setting/first-view/?restaurant_id=${restaurantIdWithoutHyphens}` : null,
        fetchFirstViewOptions
    );

    return {
        firstViewData: data,
        isLoading,
        error,
    };
};